import { AbstractControl, ValidatorFn } from '@angular/forms';

export function NotEqualValidator(compareToValue: string): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } => {
    if (control.value) {
      let val: string = control.value.toString();
      if (val.toLowerCase() == compareToValue.toLowerCase()) {
        return { 'notEqual': true };
      }
      else {
        return null;
      }
    }
  };
}
